import { NewTypography as Typography, RoundButton } from '@lamimed/pantheon';
import { LogOut } from 'lucide-react';

import { useLogout } from 'hooks/useLogout';

import { AlertBox } from 'components/AlertBox';

interface LogoutDialogProps {
  open: boolean;
  onClose: () => void;
}

export const LogoutDialog = ({ open, onClose }: LogoutDialogProps) => {
  const { logout } = useLogout();

  return (
    <AlertBox
      open={open}
      onClose={onClose}
      title="Logout"
      icon={LogOut}
      footer={
        <AlertBox.Footer>
          <RoundButton
            borderWidth="thin"
            borderColor="dark"
            expanded
            shrinked
            variant="transparent"
            onClick={onClose}
          >
            No
          </RoundButton>

          <RoundButton expanded shrinked onClick={logout}>
            Sì
          </RoundButton>
        </AlertBox.Footer>
      }
    >
      <Typography variant="body_text_3" marginBottom="none">
        Sei sicuro di voler uscire dal tuo account su questo dispositivo?
      </Typography>
    </AlertBox>
  );
};
